'use strict';

class CouponComponent {
    constructor (selector) {
        this.$card = $(selector);
        this.$header = this.$card.find('.card-header');
        this.opener = '#add-coupon-code';
        this.input = '#couponCode';
        this.submit = '[type="submit"]';
    }

    drawerRu () {
        this.$card.on('click', '.card-header', (e) => {
            $(e.currentTarget).toggleClass('active');
            $(e.currentTarget).next('.card-body').stop().slideToggle();
        });
    }

    drawer () {
        this.$card.find(this.opener).on('change', (e) => {
            if (this.$header.hasClass('disabled')) {
                return;
            }

            const $target = $(e.currentTarget);
            if ($target.prop('checked')) {
                this.$header.addClass('active');
                this.$header.find('.arrow-i').addClass('arrow-rotation');
                this.$header.next('.card-body-coupon').stop().slideDown();
                let $inCouponCode = $('#add-coupon-code').closest('.card.coupon-code').find('#couponCode.coupon-code-field--applied')
                if ($inCouponCode.length > 0) {
                    $('body').trigger('cart:afterCouponApply', { code: $inCouponCode.val(), uuid: '', btnAction: 'view' });
                }
            } else {
                this.$header.addClass('active');
                this.$header.find('.arrow-i').removeClass('arrow-rotation');
                this.$header.next('.card-body-coupon').stop().slideUp();
            }
        });
    }

    input () {
        this.$card.on('keyup', this.input, (e) => {
            this.$card.find(this.submit).attr('disabled', $(e.currentTarget).val().length === 0);
        });

        var _card = this.$card;
        var _submit = this.submit;
        this.$card.on('paste', this.input, (e) => {
            setTimeout(function () {
                _card.find(_submit).attr('disabled', $(e.currentTarget).val().length === 0);
            }, 250);
        });
    }
}

export default class Coupon extends CouponComponent {
    run () {
        if ($('meta[http-equiv=content-language]').attr('content') === 'ru-RU') {
            this.drawerRu();
        } else {
            super.drawer();
        }
        super.input();
    }
}
